import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, message } from "antd";
import api from "../api";

const { Option } = Select;

const EditProcesoModal = ({ open, record, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [productores, setProductores] = useState([]);
  const [exportadores, setExportadores] = useState([]);
  const [loadingLists, setLoadingLists] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      fetchLists();
      if (record) {
        form.setFieldsValue({
          idProductor: record.idProductor,
          idExportador: record.idExportador,
          tipoProduccion: record.tipoProduccion,
          producto: record.producto,
          nombreConductor: record.nombreConductor,
          cedulaConductor: record.cedulaConductor,
          vehiculo: record.vehiculo,
          placa: record.placa,
          guiaRemision: record.guiaRemision,
          precinto: record.precinto,
          observaciones: record.observaciones,
        });
      }
    } else {
      form.resetFields();
    }
  }, [open, record, form]);

  const fetchLists = async () => {
    setLoadingLists(true);
    try {
      const [resProd, resExp] = await Promise.all([
        api.get("/productor"),
        api.get("/exportadores")
      ]);
      setProductores(resProd.data.data || resProd.data || []);
      setExportadores(resExp.data.data || resExp.data || []);
    } catch (error) {
      message.error("Error al cargar las listas de productores/exportadores");
    } finally {
      setLoadingLists(false);
    }
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        ...values,
        idExportador: values.idExportador || null
      };
      setSaving(true);
      await api.put(`/proceso/${record.idproceso}`, payload);
      message.success("Proceso actualizado exitosamente");
      onSuccess();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        message.error(error.response.data.message);
      } else {
        message.error("Error al actualizar el proceso");
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title="Editar Datos del Proceso"
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={saving}
      okText="Actualizar"
      cancelText="Cancelar"
      width={700}
    >
      <Form form={form} layout="vertical" disabled={loadingLists}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 16px" }}>
          <Form.Item name="idProductor" label="Productor" rules={[{ required: true, message: 'El productor es obligatorio' }]}>
            <Select showSearch optionFilterProp="children">
              {productores.map(p => (
                <Option key={p.idproveedores} value={p.idproveedores}>{p.nombre}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="idExportador" label="Exportador">
            <Select showSearch optionFilterProp="children" allowClear>
              {exportadores.map(e => (
                <Option key={e.idexportadores} value={e.idexportadores}>{e.nombre}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="tipoProduccion" label="Tipo de Producción" rules={[{ required: true }]}>
            <Select>
              <Option value="Fruta al granel">Fruta al granel</Option>
              <Option value="Cajas">Cajas</Option>
            </Select>
          </Form.Item>
          <Form.Item name="producto" label="Producto" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="nombreConductor" label="Nombre Conductor" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="cedulaConductor" label="Cédula Conductor" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="vehiculo" label="Vehículo" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="placa" label="Placa" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="guiaRemision" label="Guía Remisión" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="precinto" label="Precinto" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </div>
        <Form.Item name="observaciones" label="Observaciones">
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditProcesoModal;
